import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teller-batch',
  templateUrl: './teller-batch.component.html',
  styleUrls: ['./teller-batch.component.css']
})
export class TellerBatchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
